export default __webpack_public_path__ + "static/media/rejectedestimate1.5fc350d2.svg";